<template>
  <div
    id="dadian"
    class="bg-white px-3"
    style="margin: -20px; margin-top: -1rem; margin-bottom: 0 !important"
  >
    <div class="mb-2 mt-2 pt-3 sertop">
      <!-- 左边 -->
      <div class="sertop-left">
        <template>
          <span class="mr-4"
            >当前查看域名：<el-tag>{{ from.client }} </el-tag></span
          >
          <!-- <span>快捷查看： </span> -->
          <!-- <el-button
            class="mr-2"
            @click="faskSearch('all')"
            type="primary"
            size="mini"
            v-auth="'add' + auth_val"
            >全部</el-button
          >
          <el-button
            class="mr-2"
            @click="faskSearch('android')"
            type="primary"
            size="mini"
            v-auth="'add' + auth_val"
            >安卓</el-button
          >
          <el-button
            class="mr-2"
            @click="faskSearch('ios')"
            type="primary"
            size="mini"
            v-auth="'add' + auth_val"
            >苹果</el-button
          >

          <el-button
            class="mr-2"
            @click="faskSearch('pc')"
            type="primary"
            size="mini"
            v-auth="'add' + auth_val"
            >PC</el-button
          > -->
          <!-- <el-button
            class="mr-2"
            @click="faskSearch('h5')"
            type="primary"
            size="mini"
            v-auth="'add' + auth_val"
            >H5</el-button
          > -->

          <!-- <el-button
            class="mr-2"
            @click="faskSearch('majiaxxx')"
            type="primary"
            size="mini"
            v-auth="'add' + auth_val"
            >马甲</el-button
          > -->
        </template>
      </div>

      <div class="sertop-right">
        <el-form inline ref="form" :model="from" label-width="100px">
          <el-form-item label="" size="small" class="mb-0">
            <!-- <el-date-picker
              v-model="from.date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              align="right"
              type="date"
              placeholder="选择日期"
            >
            </el-date-picker> -->
            <el-date-picker
              v-model="from.date"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item class="mb-0">
            <el-button type="info" @click="getdata" size="small"
              >搜索
            </el-button>
            <el-button size="small" @click="clearSearch"
              >清空筛选条件</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="dadstyle">
      <!-- 店铺 其他统计 -->

      <el-row :gutter="20" class="mt-3">
        <el-col :span="12">
          <el-card class="box-card" style="height: 370px" shadow="hover">
            <div slot="header" class="clearfix">
              <span>浏览器访问量</span>
              <div class="rights">
                <span
                  :style="{
                    'background-color': browser ? '#008080' : '#f2f2f2',
                    color: browser ? '#ffffff' : '#303133',
                  }"
                  @click="
                    (browser = true), browserdataall(dataall.browser_data.total)
                  "
                  >总量</span
                >
                <span
                  :style="{
                    'background-color': !browser ? '#008080' : '#f2f2f2',
                    color: !browser ? '#ffffff' : '#303133',
                  }"
                  @click="
                    (browser = false),
                      browserdataall(dataall.browser_data.dis_total)
                  "
                  >去重</span
                >
              </div>
            </div>
            <el-table height="270" :data="browserdata" style="width: 100%">
              <el-table-column
                align="center"
                type="index"
                label="排序"
                width="50"
              >
              </el-table-column>

              <el-table-column prop="name" align="center" label="来源">
                <template slot-scope="v">
                  <span>{{
                    v.row.name == "unknown" ? "未知" : v.row.name
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="value" align="center" label="数量">
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
        <!-- 左边 -->
        <el-col :span="12">
          <el-card class="box-card" style="height: 370px" shadow="hover">
            <div slot="header" class="clearfix">
              <span>事件数据</span>
              <span class="header-exp" @click="exportdata()">导出</span>
              <div class="rights">
                <span
                  :style="{
                    'background-color': rights ? '#008080' : '#f2f2f2',
                    color: rights ? '#ffffff' : '#303133',
                  }"
                  @click="
                    (rights = true), clickdataall(dataall.click_data.total)
                  "
                  >总量</span
                >
                <span
                  :style="{
                    'background-color': !rights ? '#008080' : '#f2f2f2',
                    color: !rights ? '#ffffff' : '#303133',
                  }"
                  @click="
                    (rights = false), clickdataall(dataall.click_data.dis_total)
                  "
                  >去重</span
                >
              </div>
            </div>
            <el-table height="270" :data="clickdata" style="width: 100%">
              <el-table-column
                align="center"
                type="index"
                label="排序"
                width="50"
              >
              </el-table-column>

              <el-table-column prop="name" align="center" label="来源">
              </el-table-column>
              <el-table-column prop="value" align="center" label="数量">
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
        <!-- 右边 -->
      </el-row>
      <el-row :gutter="20" class="mt-3">
        <el-col :span="24">
          <el-card class="box-card chart1" style="" shadow="hover">
            <div slot="header" class="clearfix">
              <div>
                <span>当日每小时统计数据</span>
              </div>
              <div>
                <span>总访问量：</span>
                <span class="mr-4">{{ dataall.total }}</span>
                <span>去重访问量：</span>
                <span class="mr-4">{{ dataall.dis_total }}</span>
              </div>
            </div>
            <div ref="myChart1" style="width: 100%; height: 300px"></div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import common from "@/common/mixins/common.js";
import echarts from "echarts";
import ExportJsonExcel from "js-export-excel";
export default {
  inject: ["layout"],
  mixins: [common],
  data() {
    return {
      type: "",
      check_url: "",
      onlineNum: 0,
      editIndex: -1,
      //搜索数据
      from: {
        date: [],
        client: "h5",
      },
      model_title: "Host",
      auth_val: "Mtlog",
      // preUrl: "data/dadianList", //列表地址
      tableData: [],
      form: {
        id: 0,
        remark: "",
      },
      prop: "date",
      sort: "descending",
      data: {},
      dataall: {
        total: 0,
        dis_total: 0,
        browser_data: [],
        click_data: [],
        time_data: [],
      },
      xAxisdata: [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
      ],
      time_data: {
        total: [],
        distotal: [],
      },
      clickdata: [],
      rights: true,
      browserdata: [],
      browser: true,
    };
  },
  watch: {},

  created() {
    this.getdata();
  },
  methods: {
    faskSearch(url) {
      this.from.client = url;
      this.getdata();
    },
    getdata() {
      // start_date：开始日期，end_date：结束日期
      let start_date = "";
      let end_date = "";
      this.dataall = {
        total: 0,
        dis_total: 0,
        browser_data: {
          dis_total: {},
          total: {},
        },
        click_data: {
          dis_total: {},
          total: {},
        },
        time_data: {
          dis_total: {},
          total: {},
        },
      };
      if (this.from.date.length == 2) {
        start_date = this.from.date[0];
        end_date = this.from.date[1];
      }
      this.layout.loading = true;
      this.api
        .post(
          "/data/dadianList",
          {
            client: this.from.client,
            date: this.from.date,
            start_date: start_date,
            end_date: end_date,
          },
          
        )
        .then((res) => {
          this.data = JSON.parse(JSON.stringify(res.data.data.list.data));
          console.log(res.data.data.list.data, "---打点数据---");
          // total：总访问量
          // dis_total：去重访问量
          // browser_data：浏览器访问量
          // click_data：事件数据
          // time_data：每小时统计数据
          for (let i in this.data) {
            // 总访问量
            this.dataall.total += this.data[i].total;
            // 去重访问量
            this.dataall.dis_total += this.data[i].dis_total;
            // 浏览器数据处理
            this.browserdataoncis(this.data[i].browser_data);
            // 事件数据处理
            this.clickdataoncis(this.data[i].click_data);
            // 每小时数据处理
            this.timedataoncis(this.data[i].time_data);
          }
          this.layout.loading = false;
          this.Chart();
          this.rights = true;
          this.browser = true;
          // this.clickdataall(this.data.click_data.total);
          // this.browserdataall(this.data.browser_data.total);
        })
        .catch((err) => {
          this.layout.loading = false;
        });
    },
    timedataoncis(value) {
      let data = JSON.parse(JSON.stringify(value));
      // 每小时数据
      let arr1 = this.dataall.time_data.total;
      let arr2 = this.dataall.time_data.dis_total;
      let clicktotal = data.total;
      let clickistotal = data.dis_total;

      // 所有访问量
      if (Object.keys(arr1).length == 0) {
        arr1 = clicktotal;
      } else {
        for (let i in clicktotal) {
          // 如果没有这个键值就直接赋值
          if (arr1[i] != "" && arr1[i] != null && arr1[i] != undefined) {
            arr1[i] += clicktotal[i];
          } else {
            arr1[i] = clicktotal[i];
          }
        }
      }
      // 去重访问量
      if (Object.keys(arr2).length == 0) {
        arr2 = clickistotal;
      } else {
        for (let i in clickistotal) {
          if (arr2[i] != "" && arr2[i] != null && arr2[i] != undefined) {
            arr2[i] += clickistotal[i];
          } else {
            arr2[i] = clickistotal[i];
          }
        }
      }

      this.dataall.time_data.total = arr1;
      this.dataall.time_data.dis_total = arr2;
    },
    clickdataoncis(value) {
      let data = JSON.parse(JSON.stringify(value));
      // 事件数据
      let arr1 = this.dataall.click_data.total;
      let arr2 = this.dataall.click_data.dis_total;
      let clicktotal = data.total;
      let clickistotal = data.dis_total;

      // 所有访问量
      if (Object.keys(arr1).length == 0) {
        arr1 = clicktotal;
      } else {
        for (let i in clicktotal) {
          // 如果没有这个键值就直接赋值
          if (arr1[i] != "" && arr1[i] != null && arr1[i] != undefined) {
            arr1[i] += clicktotal[i];
          } else {
            arr1[i] = clicktotal[i];
          }
        }
      }
      // 去重访问量
      if (Object.keys(arr2).length == 0) {
        arr2 = clickistotal;
      } else {
        for (let i in clickistotal) {
          if (arr2[i] != "" && arr2[i] != null && arr2[i] != undefined) {
            arr2[i] += clickistotal[i];
          } else {
            arr2[i] = clickistotal[i];
          }
        }
      }

      this.dataall.click_data.total = arr1;
      this.dataall.click_data.dis_total = arr2;
      this.clickdataall(this.dataall.click_data.total);
    },
    browserdataoncis(value) {
      let data = JSON.parse(JSON.stringify(value));
      // 浏览器访问量
      let barowtotal = data.total;
      let arrall = this.dataall.browser_data.total;
      let browdistotal = data.dis_total;
      let arrste = this.dataall.browser_data.dis_total;

      // 所有访问量
      if (Object.keys(arrall).length == 0) {
        arrall = barowtotal;
      } else {
        for (let i in barowtotal) {
          // 如果没有这个键值就直接赋值
          if (arrall[i] != "" && arrall[i] != null && arrall[i] != undefined) {
            arrall[i] += barowtotal[i];
          } else {
            arrall[i] = barowtotal[i];
          }
        }
      }

      // 去重访问量
      if (Object.keys(arrste).length == 0) {
        arrste = browdistotal;
      } else {
        for (let i in browdistotal) {
          if (arrste[i] != "" && arrste[i] != null && arrste[i] != undefined) {
            arrste[i] += barowtotal[i];
          } else {
            arrste[i] = barowtotal[i];
          }
        }
      }

      this.dataall.browser_data.total = arrall;
      this.dataall.browser_data.dis_total = arrste;
      this.browserdataall(this.dataall.browser_data.total);
    },
    exportdata() {
      // 导出excel文件
      let data = JSON.parse(JSON.stringify(this.data));
      let arr = [];
      if (this.rights) {
        // 全部数据
        for (let i in data) {
          let stetime = [];
          stetime = data[i].click_data.total;
          stetime["时间"] = data[i].date;
          arr.push(stetime);
        }
      } else {
        // 去重数据
        for (let i in data) {
          let stetime = [];
          stetime = data[i].click_data.dis_total;
          stetime["时间"] = data[i].date;
          arr.push(stetime);
        }
      }
      // console.log(arr);
      this.exportExcel(arr);
    },
    exportExcel(value) {
      // 调用插件导出文件
      const dataList = value;
      let option = {}; //   option代表的就是excel文件
      let dataTable = []; //   dataTable代表excel文件中的数据内容
      let sheetHeaderdata = []; // 表头
      if (dataList) {
        for (let i in dataList) {
          let obj = dataList[i];
          dataTable.push(obj); //   设置excel每列获取的数据源
        }
        if (dataList.length > 0) {
          for (let i in dataList[0]) {
            if(i != "时间"){
              sheetHeaderdata.push(i);
            }
          }
          sheetHeaderdata.unshift("时间");
        }
      }
      option.fileName = "事件数据"; //excel文件名
      //excel文件数据
      option.datas = [
        {
          //   excel文件的数据源
          sheetData: dataTable,
          //   excel文件sheet的表名
          sheetName: "sheet",
          //   excel文件表头名
          sheetHeader: sheetHeaderdata,
          //   excel文件列名
          sheetFilter: sheetHeaderdata,
          columnWidths: ['8','4'], // 宽度
        },
      ];
      //   创建ExportJsonExcel实例对象
      let toExcel = new ExportJsonExcel(option);
      //   调用保存方法
      toExcel.saveExcel();
    },
    // 清空筛选条件
    clearSearch() {
      this.from = {
        date: "",
        client: "h5",
      };
      this.getdata();
    },
    clickdataall(data) {
      // 事件数据升序
      this.clickdata = [];
      for (let i in data) {
        this.clickdata.push({
          value: data[i],
          name: i,
        });
      }
      this.clickdata.sort((a, b) => {
        return b.value - a.value;
      });
    },
    browserdataall(data) {
      // 浏览器数据升序
      this.browserdata = [];
      for (let i in data) {
        this.browserdata.push({
          value: data[i],
          name: i,
        });
      }
      this.browserdata.sort((a, b) => {
        return b.value - a.value;
      });
    },
    Chart() {
      // 折线图数据处理
      this.time_data.total = [];
      this.time_data.distotal = [];
      let total = this.dataall.time_data.total;
      let distotal = this.dataall.time_data.dis_total;
      if (total && distotal) {
        for (let i in total) {
          this.time_data.total.push(total[i]);
        }
        for (let i in distotal) {
          this.time_data.distotal.push(distotal[i]);
        }
      }
      this.drawLine();
    },
    drawLine() {
      //初始化echarts实例
      let myChart = echarts.init(this.$refs.myChart1);
      // 配置参数

      myChart.setOption({
        title: {
          // text: '总访问量 | 去重访问量'
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["总访问量", "去重访问量"],
          top: "30px",
        },
        grid: {
          left: "0%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          name: "时",
          data: this.xAxisdata,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "总访问量",
            type: "line",
            data: this.time_data.total,
          },
          {
            name: "去重访问量",
            type: "line",
            data: this.time_data.distotal,
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sertop {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::v-deep .el-form-item__content,
::v-deep.el-form--inline .el-form-item {
  vertical-align: middle;
}
::v-deep .el-range-separator {
  width: 10%;
}
.dadstyle {
  padding-bottom: 20px;
}
.clearfix {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.clearfix::after {
  display: none;
}
.rights {
  span {
    width: 70px;
    text-align: center;
    font-size: 14px;
    padding: 2px 5px;
    background-color: #f2f2f2;
    display: inline-block;
    cursor: pointer;
  }
}
.header-exp {
  display: inline-block;
  width: 70px;
  text-align: center;
  margin-left: 20px;
  color: #ffffff;
  font-size: 14px;
  padding: 2px 5px;
  cursor: pointer;
  background-color: #008080;
}
</style>
